module.exports = __webpack_public_path__ + "img/seating-map.a20e962f.png";